
<template>
  <div class="start-dateinput md:ml-8 md:w-2/4 w-full">
    <p>Date of Birth</p>

    <date-picker
      :value="dateOfBirth"
      :input-attr="{ 'aria-label': 'Date of Birth' }"
      :disabled="disabled"
      :disabled-date="(date) => date >= new Date()"
      placeholder="YYYY-MM-DD"
      format="YYYY-MM-DD"
      value-type="YYYY-MM-DD"
      class="text-gray-900 text-sm mt-4"
      :default-value="new Date('2000-01-01')"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
//import 'vue2-datepicker/locale/sv';
import 'vue2-datepicker/index.css';

export default {
  name: 'DateOfBirth',
  components: { DatePicker },
  props: {
    dateOfBirth: {
      type: String,
      default: null
    },
    disabled: Boolean
  }
};
</script>
